module.exports = __webpack_public_path__ + "static/profile-d6269abcbf0367a40342a0463151e6b4.png";